let mutations = {
  setInfoList: (state, data) => {
    state.infoList = data
  },

}
export default mutations
